// extracted by mini-css-extract-plugin
export default {"container":"Jumplinks_container__ZW1s5","hr":"Jumplinks_hr__kDTV-","links":"Jumplinks_links__dx2pr","link":"Jumplinks_link__syshf","all":"Jumplinks_all__NH61l"};